<template>
  <section id="about" class="about">
    <div class="section-title">
      <h2>高教深耕計畫成果(Higher Education Sprout Project)</h2>
    </div>

    <div v-for="(item, key) in project" :key="key">
      <hr />
      <h2 class="HESP-title-2">{{ item.title }}</h2>
      <hr />
      <div v-for="(subItem, subKey) in item.content" :key="subKey">
        <p class="HESP-content">{{ subItem.subtitle }}</p>
        <iframe
          width="560"
          height="315"
          :src="subItem.path"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "higherEduSproutProject",
  data() {
    return {
      project: [
        {
          title: "A-1-1:全校程式設計課程",
          content: [
            {
              subtitle: "106學年度 寫個APP也可以這麼無厘頭",
              path: "https://www.youtube.com/embed/zJYgNwMnSto",
            },
            {
              subtitle: "106學年度 程式就是可以如此動手做",
              path: "https://www.youtube.com/embed/uuXf7nson9w",
            },
          ],
        },
        {
          title: "A-1-2:專業技術社會服務學習課程",
          content: [
            {
              subtitle: "106學年度 強化科技與人文教學",
              path: "https://www.youtube.com/embed/ulZ9cNbxq8g",
            },
          ],
        },
        {
          title: "A-1-3:雙軌核心證照輔導",
          content: [
            {
              subtitle: "107學年度 國際專班專業證照、程式輔導",
              path: "https://www.youtube.com/embed/YkNNgD3fStU",
            },
            {
              subtitle: "107學年度 雙軌核心證照輔導",
              path: "https://www.youtube.com/embed/GZohk4PDB60",
            },
            {
              subtitle: "107學年度 物聯網三方共構風吹仿生獸",
              path: "https://www.youtube.com/embed/Znm4zruxroA",
            },
            {
              subtitle: "107學年度 行動裝置APP設計核心證照實作",
              path: "https://www.youtube.com/embed/URwKHOQUwa8",
            },
            {
              subtitle: "106學年度 資工核心證照輔導",
              path: "https://www.youtube.com/embed/uD9LhO7Ee6E",
            },
          ],
        },
        {
          title: "A-2-2:開設核心技術課程",
          content: [
            {
              subtitle: "106學年度 生活化核心技術程式設計",
              path: "https://www.youtube.com/embed/f-X_eqGrsVA",
            },
          ],
        },
        {
          title: "A-4-7:磨課師MOOCs課程",
          content: [
            {
              subtitle: "106學年度 磨課師MOOCS-實作基礎物聯網",
              path: "https://www.youtube.com/embed/8I_3J2loAJY",
            },
          ],
        },
        {
          title: "A-7-3：維護品保之師培方案(創新課程微學分)",
          content: [
            {
              subtitle: "",
              path: "https://www.youtube.com/embed/Ub0WRlRQGaw",
            },
          ],
        },
        {
          title: "B-1-5：培育金匠教學特色",
          content: [
            {
              subtitle: "106學年度 資訊工程系數位創客暨資訊志工領袖體驗營",
              path: "https://www.youtube.com/embed/PHSNfYEDlaI",
            },
          ],
        },
        {
          title: "C-2-1：推動勤益終身學習堂",
          content: [
            {
              subtitle:
                "106學年度 磨課師MOOCS-實作基礎物聯網106學年度全國高中職iClone3D動畫研習營",
              path: "https://www.youtube.com/embed/2E6lRIyDNxk",
            },
          ],
        },
        {
          title: "A0─落實教學創新及提升教學品質",
          content: [
            {
              subtitle: "",
              path: "https://www.youtube.com/embed/DOu-z20k9ds",
            },
          ],
        },
        {
          title: "A-4-3模組化翻轉教學",
          content: [
            {
              subtitle: "",
              path: "https://www.youtube.com/embed/PeClJswstLM",
            },
          ],
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}

@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
  cursor: pointer;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  text-align: center;
  padding-bottom: 30px;
}

.section-title h2 {
  font-family: "NotoSansTC_Bold";
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}

.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# publicaiton
--------------------------------------------------------------*/
.HESP-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 4vh;
  text-align: center;
}

.HESP-title-2 {
  font-family: "NotoSansTC_Bold";
  font-size: 3vh;
  text-align: center;
  color: #107227;
}

.HESP-title-3 {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 2vh;
  text-align: center;
}

.HESP-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: center;
  color: #1d4d01f1;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}

.about ul {
  list-style: none;
  padding: 0;
}

.about ul li {
  padding-bottom: 10px;
}

.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}

.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
